import { render, staticRenderFns } from "./studentSee.vue?vue&type=template&id=516c7ab2&scoped=true"
import script from "./studentSee.vue?vue&type=script&lang=js"
export * from "./studentSee.vue?vue&type=script&lang=js"
import style0 from "./studentSee.vue?vue&type=style&index=0&id=516c7ab2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c7ab2",
  null
  
)

export default component.exports